<script setup lang="ts">
import type { Component } from 'vue'
import type { SectionBaseItem } from '~/models/Content/SectionBaseItem'
import { computed } from 'vue'
import { GradeType } from '~/models/GradeType'
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
import Home8To10BannerArticle from '~/components/home/home8to10/Home8To10BannerArticle.vue'
import Home5To7BannerArticle from '~/components/home/home5to7/Home5To7BannerArticle.vue'

const { gradeType, sections } = defineProps<{
  gradeType: GradeType
  sections: Array<SectionBaseItem>
  isLoading: boolean
}>()

const gradeTypeComponentMap = new Map<GradeType, Component>([
  [GradeType.Grade1To4, Home5To7BannerArticle],
  [GradeType.Grade5To7, Home5To7BannerArticle],
  [GradeType.Grade8To10, Home8To10BannerArticle],
])

const sectionCount = computed(() => Math.min(sections.length, 2))
const articleType = computed(() => gradeTypeComponentMap.get(gradeType))
</script>

<template>
  <div
    v-if="articleType"
    class="w-full"
  >
    <div
      v-if="!isLoading && sectionCount > 0"
      class="mt-8 mb-16 grid gap-x-4 gap-y-12"
      :class="sectionCount === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2 auto-rows-fr'"
    >
      <component
        :is="articleType"
        v-for="section in sections"
        :key="section.locationId"
        :section="section"
      />
    </div>

    <AuSkeletonWrapper
      v-if="isLoading"
      class="mt-8 mb-16 grid w-full grid-cols-1 gap-x-4 gap-y-12 md:grid-cols-2"
    >
      <AuSkeleton
        v-for="n in 2"
        :key="n"
        height="250px"
        width="100%"
        background="var(--color-seagreen-40)"
      />
    </AuSkeletonWrapper>
  </div>
</template>
